import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const dishesApi = createApi({
    reducerPath: 'dishes',
    baseQuery: createBaseQueryWithReauth('/dishes'),

    tagTypes: ['Dishes', 'Menus'],

    endpoints: builder => ({

        createDish: builder.mutation({
            query: ({ menu_id, formData,   }) => ({
                url: `/create?menu_id=${menu_id}`,
                method: 'POST',
                body: formData,
  
            }),
         invalidatesTags: ['Dishes', 'Menus'],
        }),

        updateDish: builder.mutation({
            query: ({ id, formData,  }) => ({
                url: `/update?id=${id}`,
                method: 'POST',
                body: formData,
              
            }),
            invalidatesTags: ['Dishes', 'Menus'],
        }),

        deleteDish: builder.mutation({
            query: (id) => ({
                url: `/delete?id=${id}`,
                method: 'POST',
            }),
       invalidatesTags: ['Dishes', 'Menus'],
        }),

        toggleDishStatus: builder.mutation({
            query: (id) => ({
                url: `/toggle-status?id=${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['Dishes', 'Menus'],
        }),

        uploadDishImage: builder.mutation({
            query: (formData) => ({
                url: `/upload-image`,
                method: 'POST',
                body: formData,
            }),
        invalidatesTags: ['Dishes', 'Menus'],
        }),
    }),
});

export const {
    useCreateDishMutation,
    useUpdateDishMutation,
    useDeleteDishMutation,
    useToggleDishStatusMutation,
    useUploadDishImageMutation,
} = dishesApi;